export default __webpack_public_path__ + "static/media/know-top-list.b2e08f82.webp";